import { render } from "./ContentTextBlockPreview.vue?vue&type=template&id=4a37a65f"
import script from "./ContentTextBlockPreview.vue?vue&type=script&lang=js"
export * from "./ContentTextBlockPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__